import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

const GeoZonasLogic = () => {
  const map = useMap();
  const drawControlRef = useRef(null);

  useEffect(() => {
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: drawnItems,
      },
      draw: {
        polygon: true,
        rectangle: true,
        circle: true,
        marker: false,
        polyline: false,
      },
    });

    drawControlRef.current = drawControl;
    map.addControl(drawControl);

    map.on(L.Draw.Event.CREATED, async (event) => {
      const layer = event.layer;
      drawnItems.addLayer(layer);

      const nombre = prompt("Nombre de la zona:");
      if (!nombre) return;

      const guardarZona = async (data) => {
        try {
          const res = await fetch("http://localhost:3000/api/geozonas/crear", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });

          const resultado = await res.json();
          if (resultado.ok) {
            alert("✅ Zona guardada exitosamente");
          } else {
            alert("❌ Error al guardar zona");
          }
        } catch (error) {
          console.error("❌ Error al guardar zona:", error);
          alert("❌ Error de red al guardar zona");
        }
      };

      if (layer instanceof L.Circle) {
        const center = layer.getLatLng();
        const radius = layer.getRadius();

        guardarZona({
          nombre,
          tipo: "circulo",
          centro_lat: center.lat,
          centro_lng: center.lng,
          radio: radius,
          coordenadas: null,
        });
      } else if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
        const latlngs = layer.getLatLngs()[0].map((p) => ({
          lat: p.lat,
          lng: p.lng,
        }));

        guardarZona({
          nombre,
          tipo: "poligono",
          centro_lat: null,
          centro_lng: null,
          radio: null,
          coordenadas: latlngs,
        });
      }
    });

    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 'l') {
        e.preventDefault();
        console.log("Ctrl + L detectado");

        const polygonDrawer = new L.Draw.Polygon(map, drawControlRef.current.options.draw.polygon);
        polygonDrawer.enable(); // ⬅️ Empieza a dibujar directamente
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [map]);

  return null;
};

const GeoZonasPage = () => {
  return (
    <div style={{ height: '100vh' }}>
      <MapContainer
        center={[19.436294, -99.072632]}
        zoom={17}
        scrollWheelZoom={true}
        style={{ height: '100%', zIndex: 1 }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <GeoZonasLogic />
      </MapContainer>
    </div>
  );
};

export default GeoZonasPage;
